import { SeatingModelSummary } from '@/__generated';
import { BusEntityType } from '@/constants';
import { apiSdk } from '@/httpClient';
import { Card, Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = { seatingModelId: string };

export default function SeatingSummary({ seatingModelId }: Props) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [summary, setSummary] = React.useState<SeatingModelSummary>();
  const { t } = useTranslation();
  React.useEffect(() => {
    if (seatingModelId) {
      setLoading(true);
      apiSdk.SeatingModelService.getSeatingModelSummary({
        seatingModelId: seatingModelId,
      })
        .then(res => {
          setSummary(res);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setSummary(undefined);
    }
  }, [seatingModelId]);
  const info = React.useMemo(() => {
    if (summary?.busEntitySummaryList) {
      let { busEntitySummaryList } = summary;
      return {
        totalSeats: busEntitySummaryList.find(x => x.type === BusEntityType.Seat)?.count || 0,
        toiletRight: busEntitySummaryList.find(x => x.type === BusEntityType.ToiletRight)?.count || 0,
        ToiletLeft: busEntitySummaryList.find(x => x.type === BusEntityType.ToiletLeft)?.count || 0,
        fridge: busEntitySummaryList.find(x => x.type === BusEntityType.Fridge)?.count || 0,
        door: busEntitySummaryList.find(x => x.type === BusEntityType.Door)?.count || 0,
      };
    }

    return {
      totalSeats: 0,
      toiletRight: 0,
      ToiletLeft: 0,
      fridge: 0,
      door: 0,
    };
  }, [summary]);
  return (
    <Spin spinning={loading}>
      <Card size="small" className="mtopo-card" title={t('busesPage_Summary')}>
        {summary ? (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Seats
              <b>{info.totalSeats}</b>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {t('Toilet Right')}
              <b>{info.toiletRight}</b>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              {t('Toilet left')}
              <b>{info.ToiletLeft}</b>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Door
              <b>{info.door}</b>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              Fridge
              <b>{info.fridge}</b>
            </div>
          </>
        ) : null}
      </Card>
    </Spin>
  );
}
